import PropTypes from 'prop-types'
import classNames from 'classnames'

import Modal from '../../../../common/Modal'
import SubmitButton from '../../../../common/buttons/SubmitButton'
import CancelButton from '../../../../common/buttons/CancelButton'

import classes from './RegistrationAuthModal.module.scss'

const RegistrationAuthModal = ({ isOpen, onClose, onCreateAccount, onLogin }) => (
  <Modal isOpen={isOpen} onClose={onClose} className={classes.modal}>
    <div className='d-flex flex-column align-items-center text-center'>
      <h2 className={classNames(classes.title, 'mb-3')}>Ready to Register?</h2>
      <p className={classNames(classes.message, 'mb-5')}>
        Log in to your Op 36 account or create a free one to register for this program, track your progress, and connect with your coach.
      </p>

      <div className='row w-100'>
        <div className='col-6'>
          <SubmitButton type='button' buttonMessage='Create an Account' onClick={onCreateAccount} noTopMargin />
        </div>

        <div className='col-6'>
          <CancelButton onClick={onLogin} buttonMessage='Login' />
        </div>
      </div>
    </div>
  </Modal>
)

RegistrationAuthModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateAccount: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
}

export default RegistrationAuthModal
